import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' }
];

function LanguageSelector() {
  const { i18n, t } = useTranslation();

  // Normalize language (ex: 'fr-FR' -> 'fr')
  const currentNormalizedLang = i18n.language?.split('-')[0] || 'fr';
  const currentLanguage = languages.find(lang => lang.code === currentNormalizedLang) || languages[0];

  const otherLanguage = languages.find(lang => lang.code !== currentNormalizedLang) || languages[1];

  const handleToggleLanguage = () => {
    i18n.changeLanguage(otherLanguage.code);
  };

  return (
    <Tooltip arrow title={t('user.changeLanguage')}>
      <IconButton
        color="primary"
        onClick={handleToggleLanguage}
        sx={{
          ml: 1,
          width: 40,
          height: 40
        }}
      >
        <span style={{ fontSize: '1.2rem' }}>{currentLanguage.flag}</span>
      </IconButton>
    </Tooltip>
  );
}

export default LanguageSelector;
